import styled from '@emotion/styled';
import { Variables } from '../../../base/variables';
import * as Shared from '../form.styles';

export const FormContainer = Shared.FormContainer;
export const FormGrid = Shared.FormGrid;
export const FormField = Shared.FormField;
export const Label = Shared.Label;


export const InfoBanner = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
    background-color: ${Variables.Colors.b300_l96};
    border: 1px solid ${Variables.Colors.b300_l90};
    border-radius: 4px;
    font-size: 14px;
    color: ${Variables.Colors.n100};
`;

export const InfoIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${Variables.Colors.b300};
    color: ${Variables.Colors.white};
    font-weight: bold;
    font-size: 12px;
    flex-shrink: 0;
    margin-top: 2px;
`;

export const InfoContent = styled.div`
    flex: 1;
`;

export const SuccessBanner = styled(InfoBanner)`
    background-color: ${Variables.Colors.g50};
    border-color: ${Variables.Colors.g75};
    color: ${Variables.Colors.g300};
`;

export const SuccessIcon = styled(InfoIcon)`
    background-color: ${Variables.Colors.g100};
`;

export const SavingIndicator = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background-color: ${Variables.Colors.n15_24};
    border-radius: 4px;
    font-size: 12px;
    color: ${Variables.Colors.n70};
`;

export const VisitNumberRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    flex-wrap: nowrap;
`;

export const VisitNumberField = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const VisitNumberActions = styled.div`
    display: inline-flex;
    flex-shrink: 0;
    /* Align button with input field from top - works with and without validation errors */
    align-self: flex-start;
    margin-top: 24px;
`;

